import { CaseSelector } from './CaseSelector';
import type { ProductProps } from 'tsconfig/types';

interface Props {
  upsellProduct: ProductProps | null;
  upsellSelected: boolean;
  handleUpsellClick: () => void;
  index: number;
}

export const UpsellSelector = ({ upsellProduct, upsellSelected, handleUpsellClick, index }: Props) => {
  if (!upsellProduct) {
    return null;
  }

  return (
    <div className="mcs-main-row mcs-main-row--upsell">
      <span>Make it a bundle</span>
      <div>
        <input
          type="checkbox"
          name="mcs-bundle-upsell"
          id={`mcs-bundle-upsell-${upsellProduct.itemCode}`}
          checked={upsellSelected}
          onChange={handleUpsellClick}
        />
        <label htmlFor={`mcs-bundle-upsell-${upsellProduct.itemCode}`}>
          <CaseSelector
            type={'upsell'}
            item={upsellProduct}
            index={index}
            handleClick={handleUpsellClick}
            upsellSelected={upsellSelected}
          />
        </label>
      </div>
    </div>
  );
};
